import React, { useEffect, useState } from 'react';
import axios from 'axios';
import DeploymentModal from '../DeploymentModal';
import { API_BASE_URL } from '../../config/api';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faGlobe,
  faUndo,
} from '@fortawesome/free-solid-svg-icons';

const ProductionDeployView: React.FC = () => {
  const [clearingOTA, setClearingOTA] = useState(false);
  const [selectedGroups, setSelectedGroups] = useState<{ [key: string]: boolean }>({});
  const [statusMessage, setStatusMessage] = useState<string | null>(null);
  const [error, setError] = useState<string | null>(null);

  const alphabet = Array.from({ length: 26 }, (_, i) => String.fromCharCode(65 + i));

  useEffect(() => {
    const groups: { [key: string]: boolean } = {};
    alphabet.forEach((letter) => {
      groups[letter] = false;
    });
    setSelectedGroups(groups);
  }, []);

  const handleClearAllOTA = async () => {
    if (!window.confirm('Are you sure you want to clear all OTA flags across the entire fleet?')) {
      return;
    }

    setClearingOTA(true);
    setError(null);
    try {
      await axios.post(
        `${API_BASE_URL}/devices/clear-all-ota`,
        { markedForUpdate: false },
        { withCredentials: true }
      );
      setStatusMessage('All OTA flags cleared.');
    } catch (err: any) {
      console.error('Error clearing OTA flags:', err);
      setError('Failed to clear OTA flags');
    } finally {
      setClearingOTA(false);
    }
  };

  return (
    <div className="container-fluid mt-3">
      <div className="row mb-4">
        <div className="col">
          <h2 className="mb-1">
            <FontAwesomeIcon icon={faGlobe} className="me-2 text-danger" />
            Production
          </h2>
          <p className="text-muted mb-0">
            Global OTA settings and production group deployments.
          </p>
        </div>
      </div>

      {statusMessage && (
        <div className="alert alert-success alert-dismissible fade show" role="alert">
          {statusMessage}
          <button type="button" className="btn-close" onClick={() => setStatusMessage(null)} aria-label="Close" />
        </div>
      )}

      {error && (
        <div className="alert alert-danger alert-dismissible fade show" role="alert">
          {error}
          <button type="button" className="btn-close" onClick={() => setError(null)} aria-label="Close" />
        </div>
      )}

      <div className="row g-3 mb-3">
        <div className="col-12">
          <div className="card h-100 shadow-sm border-0">
            <div className="card-header bg-white border-0 pb-0">
              <div className="d-flex align-items-center gap-2">
                <span
                  className="d-inline-flex align-items-center justify-content-center rounded-circle bg-warning-subtle text-warning"
                  style={{ width: '2rem', height: '2rem' }}
                >
                  <FontAwesomeIcon icon={faUndo} />
                </span>
                <h5 className="mb-0">Fleet-wide Action</h5>
              </div>
              <div className="text-muted small">Clear every OTA flag across all deployment types.</div>
            </div>
            <div className="card-body d-flex align-items-end">
              <button
                className="btn btn-warning btn-sm"
                onClick={handleClearAllOTA}
                disabled={clearingOTA}
              >
                {clearingOTA ? (
                  <>
                    <span className="spinner-border spinner-border-sm me-1" role="status" aria-hidden="true" />
                    Clearing...
                  </>
                ) : (
                  <>
                    <FontAwesomeIcon icon={faUndo} className="me-1" /> Clear All OTA
                  </>
                )}
              </button>
            </div>
          </div>
        </div>
      </div>

      <DeploymentModal
        inline
        isOpen
        onClose={() => undefined}
        apiBaseUrl={API_BASE_URL}
        onDeploymentComplete={() => setStatusMessage('Production deployment updated.')}
        alphabet={alphabet}
        selectedGroups={selectedGroups}
        setSelectedGroups={setSelectedGroups}
      />
    </div>
  );
};

export default ProductionDeployView;
